<template>
	<el-dialog :visible.sync="isShowNavTip" :title="null" :modal="false" width="248px" :show-close="false" custom-class="nav-tip-dialog">
		<div class="nav_tip">
			<!-- 用户信息头部 -->
			<div class="nav_user_header">
				<img v-if="userInfo.photoImg" class="nav_user_avatar" :src="'data:image/png;base64,' + userInfo.photoImg" />
				<div v-else class="nav_user_avatar nav_user_avatar--text">{{ (userInfo.chName || "用").slice(-2) }}</div>
				<div class="nav_user_meta">
					<div class="nav_user_name">{{ userInfo.chName || "用户" }}</div>
					<div class="nav_user_sub">{{ userInfo.pos || userInfo.dept || userInfo.user || "" }}</div>
				</div>
			</div>
			<div class="nav_tc top_01">
				<div class="nav_tc_d" @click="userInfoClick">
					<i class="el-icon-user nav_tc_i"></i>
					<span class="nav_tc_s">个人信息</span>
					<i class="el-icon-arrow-right nav_tc_arrow"></i>
				</div>
				<div class="nav_tc_d" @click="clickChangePwd">
					<i class="el-icon-lock nav_tc_i"></i>
					<span class="nav_tc_s">修改密码</span>
					<i class="el-icon-arrow-right nav_tc_arrow"></i>
				</div>
				<div class="nav_tc_d nav_tc_logout" @click="clickLoginOut">
					<i class="el-icon-switch-button nav_tc_i"></i>
					<span class="nav_tc_s">退出登录</span>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "NavTip",
	props: {},
	data() {
		return {
			isShowNavTip: false,
			userInfo: {}
		};
	},
	components: {},
	mounted() {},
	methods: {
		showTip(userInfo) {
			this.userInfo = userInfo;
			this.isShowNavTip = true;
		},

		// 修改密码
		clickChangePwd() {
			this.$emit("click-change-pwd");
		},

		// 个人信息
		userInfoClick() {
			this.$emit("user-info-click");
		},

		// 退出登录
		clickLoginOut() {
			this.$confirm("退出登录, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				setTimeout(() => {
					// this.disconnectToHub();
					if (this.$tabs) {
						this.$tabs.reset();
					}
					localStorage.clear();
					sessionStorage.removeItem("accessToken");
					this.$router.replace({
						path: "/login"
					});
					this.$message({
						type: "success",
						message: "已退出登录!"
					});
					this.isShowNavTip = false;
				}, 300);
			});
		}
	}
};
</script>

<style scoped>
.nav_tip {
	width: 100%;
	background: #fff;
	color: #000000;
	padding: 8px;
	border-radius: 14px;
	box-sizing: border-box;
}

/* 用户信息头部 */
.nav_user_header {
	display: flex;
	align-items: center;
	padding: 10px 12px 14px;
	margin-bottom: 6px;
	border-bottom: 1px solid #f0f2f5;
}

.nav_user_avatar {
	width: 46px;
	height: 46px;
	border-radius: 50%;
	object-fit: cover;
	margin-right: 12px;
	border: 1px solid #ebeef5;
	flex-shrink: 0;
}

.nav_user_avatar--text {
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #409eff 0%, #5cadff 100%);
	color: #fff;
	font-size: 20px;
	font-weight: 600;
}

.nav_user_meta {
	min-width: 0;
	flex: 1;
}

.nav_user_name {
	font-size: 15px;
	font-weight: 600;
	color: #1f2d3d;
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.nav_user_sub {
	font-size: 12px;
	color: #909399;
	margin-top: 3px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.nav_tc {
	width: 100%;
	background: #fff;
	border-radius: 8px;
	overflow: hidden;
}

.nav_tc_d {
	width: 100%;
	height: 44px;
	padding: 0 12px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	cursor: pointer;
	box-sizing: border-box;
	transition: background-color 0.2s ease, color 0.2s ease;
}

.nav_tc_d:hover {
	background: #eef5ff;
}

.nav_tc_i {
	font-size: 17px;
	width: 20px;
	margin-right: 10px;
	color: #409eff;
	text-align: center;
	transition: color 0.2s ease;
}

.nav_tc_s {
	flex: 1;
	font-size: 14px;
	color: #334155;
}

.nav_tc_arrow {
	font-size: 12px;
	color: #c0c4cc;
	transition: transform 0.2s ease, color 0.2s ease;
}

.nav_tc_d:hover .nav_tc_s {
	color: #409eff;
}

.nav_tc_d:hover .nav_tc_arrow {
	color: #409eff;
	transform: translateX(2px);
}

/* 退出登录：分隔线 + 危险色 */
.nav_tc_logout {
	margin-top: 6px;
	padding-top: 0;
	border-top: 1px solid #f0f2f5;
	border-radius: 0 0 8px 8px;
}

.nav_tc_logout .nav_tc_i,
.nav_tc_logout .nav_tc_s {
	color: #f56c6c;
}

.nav_tc_logout:hover {
	background: #fef0f0;
}

.nav_tc_logout:hover .nav_tc_s {
	color: #f56c6c;
}

.top_01 {
	margin-top: 0;
}

/* 弹层定位到右上角、贴合内容、去除默认外观 */
::v-deep .nav-tip-dialog {
	position: absolute;
	right: 14px;
	top: 54px;
	margin: 0 !important;
	border-radius: 14px;
	border: 1px solid #eef1f6;
	box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
	overflow: hidden;
}

::v-deep .nav-tip-dialog .el-dialog__header {
	display: none;
}

::v-deep .nav-tip-dialog .el-dialog__body {
	padding: 0;
	background-color: #fff;
}
</style>
